module.exports = __webpack_public_path__ + "static/media/v29.a669ecb4.mp4";